import { createModule } from '@vue-storefront/core/lib/module'
import { afterRegistration } from './hooks/afterRegistration'

const KEY = 'forter'

export const Forter = createModule({
  key: KEY,
  afterRegistration
})
